class CreativeListing {
  constructor(el) {
    this.endpoint = window.ddb.api.ajax_url;
    this.creativeAction = window.ddb.api.creative.action;
    this.creativeToken = window.ddb.api.creative.token;

    this.$el = $(el);
    this.$container = this.$el.find(".card-container");
    this.$loadhandler = this.$el.find(".creative-load-more");

    this._isLoading = false;
    this._count = this.$container.find(".card-container__item").length; // @TODO: should change to get the data from cardcontainer component instead of checking from DOM.

    if (this.$loadhandler) {
      this.nextPage = this.$loadhandler.data("page");
      this.$loadhandler.on(
        "click",
        CreativeListing.prototype.loadMore.bind(this)
      );
    }

    this.$el.data("ddb.creativelisting", this);
  }

  generateHTMLItem(data, idx) {
    const figure = data.image
      ? `
      <figure data-url="${data.url}" data-cursor="disabled" class="card__image image is-square" role="none">
        <div class="image-cover" role="img" aria-label="" style="background-image: url(${data.image})"></div>
      </figure>
    `
      : "";

    return `
      <li class="card-container__item">
        <article class="card card--award">
          ${figure}
          <div class="card__content">
            <small class="title is-uppercase" style="padding-bottom: 0.5em;display:block;"><a href="${data.client_url}" class="has-text-grey">${data.client}</a></small>
            <h5 class="title is-6">
              <a href="${data.url}" title="Read More" class="is-link--gray" target="_self">${data.title}</a>
            </h5>
          </div>
        </article>
      </li>
    `;
  }

  async loadMore() {
    if (this._isLoading) return;

    try {
      this.setLoading(true);

      const httpRequest = await this.fetch();
      const result = httpRequest.data;

      if (result.data.list) {
        result.data.list.forEach((item) => {
          let html = this.generateHTMLItem(item, this._count);

          const cardContainer = this.$container.data("ddb.cardcontainer");
          cardContainer.add(html);
          this._count += 1;
        });
      }

      if (result.data.pagination.next_page == 0) {
        // at the end of pages.
        this.$loadhandler.fadeOut();
      } else {
        this.nextPage = result.data.pagination.next_page;
        this.setLoading(false);
      }
    } catch (error) {
      if (window.ddb.debug) {
        console.log("error", error);
      }

      this.setLoading(false);
    }
  }

  setLoading(state) {
    this._isLoading = !!state;
    this.$loadhandler.buttonloader("loading", !!state);
  }

  async fetch() {
    return axios.post(
      this.endpoint,
      Qs.stringify({
        action: this.creativeAction,
        page: this.nextPage,
        token: this.creativeToken,
      })
    );
  }
}

module.exports = CreativeListing;
